export default function RecommendationCommentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  docDataService,
  editRecommendationCommentDialog,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Recommendation Note Added';
  vm.isExpanded = false;
  vm.canEditItem = vm.canEdit;
  vm.canDeleteItem = vm.canDelete;

  // Attach Event Handlers
  vm.handleEditRecommendationComment = _handleEditRecommendationComment;
  vm.handleDeleteRecommendationComment = _handleDeleteRecommendationComment;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleEditRecommendationComment($event) {
    amDataService.getRecommendationComment(vm.recommendationComment.recommendationCommentId).then(() => {
      ssDialogService.dialogs.auditTrail.editRecommendationCommentDialog = ssDialogService.alert(
        editRecommendationCommentDialog.getOptions($event, {
          recommendationId: vm.recommendationId,
          recommendationCommentId: vm.recommendationComment.recommendationCommentId,
          recommendationCommentText: vm.recommendationComment.text,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.auditTrail.editRecommendationCommentDialog);
    });
  }

  function _handleDeleteRecommendationComment($event) {
    ssDialogService.dialogs.auditTrail.deleteRecommendationCommentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Recommendation Note?',
        message: `Are you sure you want to delete Recommendation Note "${vm.recommendationComment.text}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteRecommendationCommentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService.deleteRecommendationComment(vm.recommendationComment.recommendationCommentId)
      .then(() => {
        alerts.success('The Recommendation Note has been deleted successfully.');
        $rootScope.$broadcast('refreshAMRecommendationComments', { recommendationId: vm.recommendationComment.recommendationId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting the Recommendation Note.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteRecommendationCommentConfirmDialog);
  }
}

RecommendationCommentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'confirmDialog',
  'docDataService',
  'editRecommendationCommentDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
